export const Import = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.207 2H4.5C3.673 2 3 2.673 3 3.5V8H4V3.5C4 3.2245 4.224 3 4.5 3H8.5V6.5H12V13H4V11H3V14H13V5.793L9.207 2ZM9.5 3.707L11.293 5.5H9.5V3.707ZM6.9985 10H2V9H7.004L5.853 7.8545L6.56 7.1475L8.2095 8.7965C8.5965 9.184 8.5965 9.815 8.2095 10.2025L6.5595 11.852L5.8525 11.145L6.998 9.9995L6.9985 10Z"
      fill="currentColor"
    />
  </svg>
);
